
import ArrowSwap from "../../../assets/outline/ArrowSwap.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowSwapIcon({ className, dataTestid = "ArrowSwapIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowSwap data-testid={dataTestid} className={classes} {...rest} />
  );
}
